import { render, staticRenderFns } from "./button.vue?vue&type=template&id=6a77397c&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a77397c')) {
      api.createRecord('6a77397c', component.options)
    } else {
      api.reload('6a77397c', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=6a77397c&", function () {
      api.rerender('6a77397c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/button.vue"
export default component.exports